export default __webpack_public_path__ + "static/media/arrow_up_icon.aae427cc.svg";